export const getCategoryColor = (quadrant) => {
  if (quadrant === 'action') {
    // Red for low performance - reversed gradient ending in defined red
    return 'linear-gradient(0.25turn, #F6B091, #EE3B3B)'

  }
  if (quadrant === 'flow') {
    // Light blue/green for high performance - reversed gradient ending in defined teal
    return 'linear-gradient(0.25turn, #9FE1E4, #00B8C4)'

  }
  if (quadrant === 'watch') {
    // Yellow for medium performance - reversed gradient ending in defined yellow
    return 'linear-gradient(0.25turn, #FFE882, #FFB800)'

  }
  if (quadrant === 'ease') {
    // Purple for 100% performance - reversed gradient ending in defined purple
    return 'linear-gradient(0.25turn, #B890FF, #7B2CBF)'

  }

  return 'linear-gradient(0.25turn, #F6B091, #EE3B3B)'
}